import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';

export const DataPrivacyRequestSuccess = props => {
  const { onSubmitAnotherRequest } = props;

  return (
    <div className="py-1" data-test="data-privacy-request-thank-you">
      <p>
        Thank you for submitting your request. See our{' '}
        <a className="text-primary-darker" href="/about/privacy.html">
          Privacy Statement
        </a>{' '}
        for information about our request verification process.
      </p>
      <a className="btn btn-link" href="/">
        Go back to Edmunds.com
      </a>
      |
      <Button color="link" onClick={onSubmitAnotherRequest}>
        Submit another request
      </Button>
    </div>
  );
};

DataPrivacyRequestSuccess.propTypes = {
  onSubmitAnotherRequest: PropTypes.func.isRequired,
};
